import { apiPrefix, ConnectionService } from './Connecion.service';

const RESOURCE = 'unauth';

class UnauthService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  getServerSetting() {
    const url = `${this.basedUrl}/serverSetting`;
    return super.sendRequest(url, {}, true);
  }

  getSetting() {
    const url = `${this.basedUrl}/Setting`;
    return super.sendRequest(url, {}, true);
  }

  getNotice() {
    const url = `${this.basedUrl}/getNotice`;
    return super.sendRequest(url, {}, true);
  }
}

export default new UnauthService();